(() => {
  const root = document.querySelector('[data-cs-self-serve]');
  if (!root || root.dataset.csSelfServeReady === 'true') return;
  root.dataset.csSelfServeReady = 'true';

  // CS_SELF_SERVE_FLOATING_PILLS_V1
  // Suppress launchers only on this self-serve page.
  function suppressSelfServeFloatingPills() {
    const hide = (element) => {
      if (!element) return;

      element.style.setProperty(
        'display', 'none', 'important'
      );
      element.style.setProperty(
        'visibility', 'hidden', 'important'
      );
      element.style.setProperty(
        'pointer-events', 'none', 'important'
      );
    };

    const isSmall = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();

      return rect.width > 0 &&
        rect.height > 0 &&
        rect.width <= 520 &&
        rect.height <= 240;
    };

    const floatingAncestor = (element) => {
      let current = element;

      for (let i = 0; i < 8 && current &&
        current !== document.body; i++) {
        const position =
          window.getComputedStyle(current).position;

        if (position === 'fixed' ||
            position === 'sticky') {
          return current;
        }

        current = current.parentElement;
      }

      return null;
    };

    const hidePills = () => {
      // Existing Shop-page Smile launcher selectors.
      const smileSelectors = [
        '#smile-ui-container',
        '#smile-ui-lite-container',
        '[id^="smile-ui"]',
        '[class*="smile-launcher"]',
        '[class*="smile_launcher"]',
        'iframe[title*="Rewards" i]',
        'iframe[title*="Smile" i]',
        'iframe[src*="smile.io" i]',
        'iframe[src*="smilecdn" i]'
      ];

      document.querySelectorAll(
        smileSelectors.join(',')
      ).forEach(element => {
        hide(
          element.tagName === 'IFRAME'
            ? element.parentElement || element
            : element
        );
      });

      // Suppress only visually floating controls,
      // not regular schedule text or page navigation.
      document.querySelectorAll(
        'button, a, div, span, [role="button"], iframe'
      ).forEach(element => {
        if (element.closest(
          'header, nav, [data-cs-local-cart-dock]'
        )) return;

        const label = String(
          element.tagName === 'IFRAME'
            ? element.getAttribute('title') || ''
            : element.getAttribute('aria-label') ||
              element.textContent || ''
        ).replace(/\s+/g, ' ').trim().toLowerCase();

        if (label !== 'schedule' &&
            label !== 'rewards') return;

        const floating = floatingAncestor(element);
        if (!floating) return;

        const clickable = element.closest(
          'button, a, [role="button"]'
        );

        const target = isSmall(clickable)
          ? clickable
          : isSmall(floating)
            ? floating
            : element;

        hide(target);
      });
    };

    let queued = false;

    const scheduleHide = () => {
      if (queued) return;
      queued = true;

      window.requestAnimationFrame(() => {
        queued = false;
        hidePills();
      });
    };

    hidePills();

    const observer = new MutationObserver(scheduleHide);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener(
      'load', scheduleHide, { once: true }
    );
  }

  try {
    suppressSelfServeFloatingPills();
  } catch (error) {
    console.warn(
      'Self-serve floating controls could not be suppressed:',
      error
    );
  }


  const configElement = root.querySelector('[data-cs-self-serve-config]');
  let config = {};

  try {
    config = JSON.parse(configElement?.textContent || '{}');
  } catch (error) {
    console.error('Cold Sugar self-serve configuration could not be read.', error);
    return;
  }

  const PATH = 'parmer_self_serve';
  const productCards = Array.from(root.querySelectorAll('[data-cs-self-serve-product]'));
  const statusCard = root.querySelector('[data-cs-self-serve-status]');
  const statusLabel = root.querySelector('[data-cs-self-serve-status-label]');
  const statusTitle = root.querySelector('[data-cs-self-serve-status-title]');
  const statusCopy = root.querySelector('[data-cs-self-serve-status-copy]');
  const menuKicker = root.querySelector('[data-cs-self-serve-menu-kicker]');
  const menuTitle = root.querySelector('[data-cs-self-serve-menu-title]');
  const menuCopy = root.querySelector('[data-cs-self-serve-menu-copy]');
  const menuLink = root.querySelector('[data-cs-self-serve-menu-link]');
  const menuSection = root.querySelector('.cs-self-serve__menu');
  const notice = root.querySelector('[data-cs-self-serve-notice]');
  const dialog = root.querySelector('[data-cs-self-serve-dialog]');
  const dialogClose = root.querySelector('[data-cs-self-serve-dialog-close]');
  const dialogKeep = root.querySelector('[data-cs-self-serve-dialog-keep]');
  const dialogSwitch = root.querySelector('[data-cs-self-serve-dialog-switch]');
  const dialogError = root.querySelector('[data-cs-self-serve-dialog-error]');

  const STALE_ATTRIBUTES = [
    'Fulfillment Category', 'Fulfillment Type', 'Fulfillment Option Handle',
    'Fulfillment Option Name', 'Pickup Event ID', 'Pickup Date', 'Pickup Day',
    'Pickup Location', 'Pickup City State', 'Pickup Address', 'Pickup Window',
    'Pickup Instructions', 'Cold Sugar Pass', 'Delivery Event ID', 'Delivery Date',
    'Delivery Day', 'Delivery Area', 'Delivery Window', 'Delivery Zip Code',
    'Delivery Instructions', 'Shipping Event ID', 'Shipping Option',
    'Requested Delivery Date', 'Requested Delivery Day', 'Estimated Ship Date',
    'Shipping Method', 'Checkout Method To Select', 'Shopping Path',
    'Porch Live Purchase', 'Thursday Preorder Close Time', 'Thursday Live Open Time',
    'Thursday Live Close Time', 'Self Serve Purchase', 'Self Serve Open Time',
    'Self Serve Close Time'
  ];

  let currentSchedule = null;
  let currentState = 'preview';
  let pendingAdd = null;

  function route(path) {
    const base = window.Shopify?.routes?.root || '/';
    return `${base.replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;
  }

  function getCentralNow() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: config.timeZone || 'America/Chicago',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date());

    const values = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    return new Date(Date.UTC(
      values.year,
      values.month - 1,
      values.day,
      values.hour,
      values.minute,
      values.second
    ));
  }

  function dateFromISO(value) {
    const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
  }

  function toISODate(date) {
    return [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0'),
    ].join('-');
  }

  function atTime(date, value) {
    const [hours, minutes] = String(value || '00:00').split(':').map(Number);
    return new Date(Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      Number.isFinite(hours) ? hours : 0,
      Number.isFinite(minutes) ? minutes : 0,
      0
    ));
  }

  function formatDate(date, includeYear = false) {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric',
      ...(includeYear ? { year: 'numeric' } : {}),
    }).format(date);
  }

  function formatDay(date) {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC', weekday: 'long',
    }).format(date);
  }

  function formatClock(value) {
    const [hours, minutes] = String(value || '00:00').split(':').map(Number);
    const date = new Date(Date.UTC(2020, 0, 1, hours || 0, minutes || 0));
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC', hour: 'numeric', minute: minutes ? '2-digit' : undefined,
    }).format(date);
  }

  function findEventDate(today) {
    return dateFromISO(config.firstEventDate) || today;
  }

  function buildSchedule() {
    const now = getCentralNow();
    const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    const eventDate = findEventDate(today);

    return {
      now,
      eventDate,
      iso: toISODate(eventDate),
      openAt: atTime(eventDate, config.openTime || '09:00'),
      closingSoonAt: atTime(eventDate, config.closingSoonTime || '10:30'),
      closeAt: atTime(eventDate, config.closeTime || '11:00'),
    };
  }

  function isThemePreview() {
    const role = String(window.Shopify?.theme?.role || '').toLowerCase();
    return Boolean(
      window.Shopify?.designMode ||
      role === 'unpublished' ||
      role === 'development' ||
      ['127.0.0.1', 'localhost'].includes(window.location.hostname)
    );
  }

  function resolveState(schedule) {
    const requested = String(new URLSearchParams(window.location.search).get('preview_state') || '').toLowerCase();
    const configured = String(config.previewState || root.dataset.previewState || 'auto').toLowerCase();
    const forced = requested || configured;

    if (isThemePreview() && ['preview', 'live', 'closing', 'ended'].includes(forced)) {
      return forced;
    }

    if (schedule.now < schedule.openAt) return 'preview';
    if (schedule.now < schedule.closingSoonAt) return 'live';
    if (schedule.now < schedule.closeAt) return 'closing';
    return 'ended';
  }

  function isLive() {
    return currentState === 'live' || currentState === 'closing';
  }

  function syncPreviewContext() {
    const forced = String(
      new URLSearchParams(window.location.search).get('preview_state') ||
      config.previewState ||
      ''
    ).toLowerCase();

    try {
      if (!isThemePreview() || !['preview', 'live', 'closing', 'ended'].includes(forced)) {
        sessionStorage.removeItem('coldSugarSelfServePreviewContext');
        return;
      }

      sessionStorage.setItem('coldSugarSelfServePreviewContext', JSON.stringify({
        state: currentState,
        eventISO: currentSchedule?.iso || '',
        savedAt: Date.now(),
      }));
    } catch (error) {
      // Session storage is optional.
    }
  }

  function renderState() {
    const open = formatClock(config.openTime || '09:00');
    const close = formatClock(config.closeTime || '11:00');
    const date = formatDate(currentSchedule.eventDate);
    const copy = {
      preview: {
        tone: 'preview', label: 'Next self-serve shop', title: date,
        text: `Self-checkout opens at ${open}.`, kicker: 'Upcoming self-serve shop',
        menuTitle: 'Event menu', menuCopy: 'Browse the planned display. Purchasing unlocks at the park.',
        notice: 'Shopping will unlock at the stand during the event.', noticeTone: '',
      },
      live: {
        tone: 'live', label: 'Open now', title: 'Shop the stand',
        text: `Complete checkout before leaving. Open until ${close} or until sold out.`,
        kicker: 'Available now', menuTitle: 'Choose from the display',
        menuCopy: 'Only add items you have physically picked up from the table or bread shelf.',
        notice: 'Pay for the items in your hands before leaving the stand.', noticeTone: 'success',
      },
      closing: {
        tone: 'closing', label: 'Closing soon', title: `Closes at ${close}`,
        text: 'Choose what remains from the display.', kicker: 'Available now',
        menuTitle: 'Choose from the display', menuCopy: 'Only add items you have physically picked up from the table or bread shelf.',
        notice: 'The self-serve stand is closing soon. Pay for the items in your hands before leaving.', noticeTone: 'warning',
      },
      ended: {
        tone: 'ended', label: 'Closed', title: 'Thanks, neighbors',
        text: 'This self-serve event has ended.', kicker: 'Closed for today',
        menuTitle: 'The self-serve shop is closed', menuCopy: '',
        notice: 'Self-checkout is closed. Please do not take products from the display.', noticeTone: 'danger',
      },
    }[currentState];

    statusCard.dataset.state = copy.tone;
    statusLabel.textContent = copy.label;
    statusTitle.textContent = copy.title;
    statusCopy.textContent = copy.text;
    menuKicker.textContent = copy.kicker;
    menuTitle.textContent = copy.menuTitle;
    menuCopy.textContent = copy.menuCopy;
    notice.textContent = copy.notice;
    notice.dataset.tone = copy.noticeTone;
    productCards.forEach(updateProductCard);
  }

  function getVariantControl(card) {
    return card.querySelector('[data-cs-self-serve-variant]');
  }

  function getVariantMeta(card) {
    const control = getVariantControl(card);
    const source = control?.tagName === 'SELECT' ? control.options[control.selectedIndex] : control;
    return {
      id: Number(source?.value || 0),
      price: Number(source?.dataset.price || 0),
    };
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: 'USD',
    }).format(Number(cents || 0) / 100);
  }

  function getAction() {
    if (!isLive()) {
      return { disabled: true, label: currentState === 'ended' ? 'Self-checkout closed' : 'Available at the event' };
    }
    return { disabled: false, label: 'Add to cart' };
  }

  function updateProductCard(card) {
    const meta = getVariantMeta(card);
    const action = getAction();
    const price = card.querySelector('[data-cs-self-serve-price]');
    const button = card.querySelector('[data-cs-self-serve-add]');
    const buttonLabel = card.querySelector('[data-cs-self-serve-add-label]');
    const input = card.querySelector('[data-cs-self-serve-quantity]');
    const quantityControl = card.querySelector('[data-cs-self-serve-quantity-control]');

    if (price) price.textContent = formatMoney(meta.price);
    if (button) button.disabled = action.disabled;
    if (buttonLabel) buttonLabel.textContent = action.label;
    if (quantityControl) quantityControl.hidden = action.disabled;
    card.classList.remove('is-sold-out');

    if (input) {
      input.disabled = action.disabled;
      input.removeAttribute('max');
      input.value = String(Math.max(1, Number(input.value) || 1));
    }
  }

  function normalizeQuantity(card) {
    const input = card.querySelector('[data-cs-self-serve-quantity]');
    let value = Math.max(1, Number(input?.value) || 1);
    if (input) input.value = String(value);
    return value;
  }

  async function fetchCart() {
    const response = await fetch(route('cart.js'), {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error('Your cart could not be read. Please try again.');
    return response.json();
  }

  function isPickupLock(item) {
    const value = item?.properties?._cold_sugar_pickup_lock;
    return value === true || value === 'true' || item?.handle === 'pickup-location';
  }

  function visibleItems(cart) {
    return (cart?.items || []).filter((item) => !isPickupLock(item) && Number(item.quantity || 0) > 0);
  }

  function cartPath(cart) {
    const attributePath = String(cart?.attributes?.['Shopping Path'] || '').trim().toLowerCase();
    if (attributePath) return attributePath;
    return String(visibleItems(cart)[0]?.properties?._cold_sugar_shopping_path || '').trim().toLowerCase();
  }

  function assertAvailable() {
    const action = getAction();
    if (action.disabled) throw new Error(action.label);
  }

  function blankAttributes() {
    return STALE_ATTRIBUTES.reduce((attributes, key) => {
      attributes[key] = '';
      return attributes;
    }, {});
  }

  function buildAttributes() {
    const dateLabel = formatDate(currentSchedule.eventDate, true);
    const dayLabel = formatDay(currentSchedule.eventDate);
    const location = config.option?.displayName || 'Parmer Ranch Park - Self Serve';
    const windowLabel = config.displaySchedule || 'Saturdays · 9–11 AM';

    return {
      ...blankAttributes(),
      'Shopping Path': PATH,
      'Self Serve Purchase': 'Yes',
      'Self Serve Open Time': config.openTime || '09:00',
      'Self Serve Close Time': config.closeTime || '11:00',
      'Fulfillment Category': 'pickup',
      'Fulfillment Type': 'Self-Serve Purchase',
      'Fulfillment Option Handle': config.option?.handle || 'parmer-ranch-self-serve',
      'Fulfillment Option Name': location,
      'Pickup Event ID': `pickup-${config.option?.handle || 'parmer-ranch-self-serve'}-${currentSchedule.iso}`,
      'Pickup Date': dateLabel,
      'Pickup Day': dayLabel,
      'Pickup Location': location,
      'Pickup City State': config.option?.cityState || 'Georgetown, TX',
      'Pickup Address': config.option?.fullAddress || '',
      'Pickup Window': windowLabel,
      'Pickup Instructions': 'Self-serve purchase. Payment is complete and the customer may take only the items included in this order.',
      'Checkout Method To Select': config.option?.checkoutInstruction || `Choose Pickup in store → ${location}.`,
    };
  }

  async function clearCart() {
    const clearResponse = await fetch(route('cart/clear.js'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
    if (!clearResponse.ok) throw new Error('The current cart could not be cleared.');

    await fetch(route('cart/update.js'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: blankAttributes() }),
    });
  }

  async function addProduct(pending) {
    const response = await fetch(route('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{
          id: pending.meta.id,
          quantity: pending.quantity,
          properties: {
            _cold_sugar_order_mode: 'local',
            _cold_sugar_shopping_path: PATH,
            _cold_sugar_self_serve_event: currentSchedule.iso,
          },
        }],
      }),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.status) {
      throw new Error(payload.description || payload.message || 'This item could not be added.');
    }
  }

  async function updateCartAttributes() {
    const response = await fetch(route('cart/update.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ attributes: buildAttributes() }),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.errors || payload.status) {
      throw new Error(payload.description || payload.message || 'Self-serve checkout details could not be saved.');
    }
  }

  async function applyCartUpdates(updates) {
    if (!Object.keys(updates).length) return;
    const response = await fetch(route('cart/update.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ updates }),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.errors || payload.status) {
      throw new Error(payload.description || payload.message || 'The pickup location could not be updated.');
    }
  }

  async function syncPickupLock(cart) {
    const variantId = String(config.option?.lockVariantId || '');
    const optionHandle = String(config.option?.handle || 'parmer-ranch-self-serve');
    if (!variantId) throw new Error('The Parmer Ranch self-serve location lock is not connected yet.');

    const locks = (cart?.items || []).filter(isPickupLock);
    const exactLock = locks.find((item) =>
      String(item.variant_id || item.id || '') === variantId &&
      String(item.properties?._cold_sugar_fulfillment_option || '') === optionHandle
    );

    if (!exactLock) {
      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{
            id: Number(variantId), quantity: 1,
            properties: {
              _cold_sugar_pickup_lock: 'true',
              _cold_sugar_fulfillment_option: optionHandle,
            },
          }],
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'The Parmer Ranch pickup location could not be selected.');
      }
    }

    const refreshed = await fetchCart();
    const refreshedLocks = (refreshed.items || []).filter(isPickupLock);
    const keep = refreshedLocks.find((item) =>
      String(item.variant_id || item.id || '') === variantId &&
      String(item.properties?._cold_sugar_fulfillment_option || '') === optionHandle
    );
    if (!keep) throw new Error('The Parmer Ranch pickup location could not be confirmed.');

    const removals = {};
    refreshedLocks.forEach((item) => {
      if (item.key && item.key !== keep.key) removals[item.key] = 0;
    });
    await applyCartUpdates(removals);
  }

  async function saveContext() {
    try {
      sessionStorage.setItem('coldSugarShoppingContext', JSON.stringify({
        shoppingPath: PATH,
        fulfillmentHandle: config.option?.handle || 'parmer-ranch-self-serve',
        eventDate: currentSchedule.iso,
        savedAt: Date.now(),
      }));
    } catch (error) {
      // Session storage is optional.
    }
  }


  // CS_SELF_SERVE_CART_DOCK_V1
  let selfServeDockExpandedAtY = window.scrollY;

  function renderSelfServeCartDock(cart, expand = false) {
    const dock = root.querySelector(
      '[data-cs-local-cart-dock]'
    );
    if (!dock) return;

    const count = visibleItems(cart).reduce(
      (sum, item) => sum + Number(item.quantity || 0),
      0
    );

    if (cartPath(cart) !== PATH || count <= 0) {
      dock.hidden = true;
      dock.classList.remove('is-expanded', 'is-collapsed');
      return;
    }

    dock.hidden = false;

    const title = dock.querySelector(
      '[data-cs-local-cart-dock-title]'
    );
    const copy = dock.querySelector(
      '[data-cs-local-cart-dock-copy]'
    );
    const countNode = dock.querySelector(
      '[data-cs-local-cart-dock-count]'
    );

    if (title) {
      title.textContent =
        `${count} ${count === 1 ? 'item' : 'items'} in your cart`;
    }

    if (copy) {
      copy.textContent = 'Parmer Ranch Park · Self-serve';
    }

    if (countNode) {
      countNode.textContent = `· ${count}`;
    }

    if (expand ||
        !dock.classList.contains('is-expanded') &&
        !dock.classList.contains('is-collapsed')) {
      dock.classList.remove('is-collapsed');
      dock.classList.add('is-expanded');
      selfServeDockExpandedAtY = window.scrollY;
    }
  }

  let selfServeDockScrollQueued = false;

  window.addEventListener('scroll', () => {
    if (selfServeDockScrollQueued) return;

    selfServeDockScrollQueued = true;

    window.requestAnimationFrame(() => {
      selfServeDockScrollQueued = false;

      const dock = root.querySelector(
        '[data-cs-local-cart-dock]'
      );

      if (!dock || dock.hidden ||
          !dock.classList.contains('is-expanded')) {
        return;
      }

      if (Math.abs(
        window.scrollY - selfServeDockExpandedAtY
      ) >= 48) {
        dock.classList.remove('is-expanded');
        dock.classList.add('is-collapsed');
      }
    });
  }, { passive: true });

  fetchCart()
    .then(cart => renderSelfServeCartDock(cart))
    .catch(error => {
      console.warn('Self-serve cart dock initialization:', error);
    });

  async function refreshCartUi(cart) {
    const notification = document.querySelector(
      'cart-notification'
    );

    if (notification &&
        typeof notification.refreshCartBubble === 'function') {
      try {
        await notification.refreshCartBubble();
      } catch (error) {
        console.error('Cart badge refresh failed:', error);
      }
    }

    renderSelfServeCartDock(cart, true);

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart }
      })
    );
  }

  async function completeAdd(pending) {
    let cart = await fetchCart();
    assertAvailable();
    await addProduct(pending);
    await updateCartAttributes();
    cart = await fetchCart();
    await syncPickupLock(cart);
    await saveContext();
    const updatedCart = await fetchCart();
    await refreshCartUi(updatedCart);
    const message = pending.card.querySelector('[data-cs-self-serve-message]');
    if (message) message.textContent = 'Added to cart.';
  }

  function openDialog() {
    if (!dialog) return;
    dialogError.textContent = '';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function closeDialog() {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  async function handleSubmit(card) {
    const button = card.querySelector('[data-cs-self-serve-add]');
    const message = card.querySelector('[data-cs-self-serve-message]');
    const pending = { card, meta: getVariantMeta(card), quantity: normalizeQuantity(card) };
    if (message) message.textContent = '';

    try {
      const action = getAction();
      if (button?.disabled || action.disabled) throw new Error(action.label);

      if (!window.ColdSugarOrderMode || typeof window.ColdSugarOrderMode.beforeAnyAdd !== 'function') {
        throw new Error('Cart protection is still loading. Please wait a moment and try again.');
      }

      const mayContinue = await window.ColdSugarOrderMode.beforeAnyAdd({ trigger: button });
      if (!mayContinue) return;
      button.disabled = true;

      const cart = await fetchCart();
      assertAvailable();
      const needsFreshCart = visibleItems(cart).length > 0 && cartPath(cart) !== PATH;

      if (needsFreshCart) {
        pendingAdd = pending;
        openDialog();
        return;
      }

      await completeAdd(pending);
    } catch (error) {
      if (message) message.textContent = error.message || 'This item could not be added.';
    } finally {
      updateProductCard(card);
    }
  }

  async function confirmSwitch() {
    if (!pendingAdd) return;
    dialogSwitch.disabled = true;
    dialogKeep.disabled = true;
    dialogClose.disabled = true;
    dialogSwitch.textContent = 'Starting self-checkout…';

    try {
      await clearCart();
      await completeAdd(pendingAdd);
      pendingAdd = null;
      closeDialog();
    } catch (error) {
      dialogError.textContent = error.message || 'The cart could not be switched.';
    } finally {
      dialogSwitch.disabled = false;
      dialogKeep.disabled = false;
      dialogClose.disabled = false;
      dialogSwitch.textContent = 'Clear cart & start self-checkout';
    }
  }

  function bindEvents() {
    menuLink?.addEventListener('click', (event) => {
      event.preventDefault();
      if (!menuSection) return;

      menuSection.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });

      if (window.history?.replaceState) {
        window.history.replaceState(null, '', '#SelfServeMenu');
      } else {
        window.location.hash = 'SelfServeMenu';
      }
    });

    productCards.forEach((card) => {
      const input = card.querySelector('[data-cs-self-serve-quantity]');
      const variant = getVariantControl(card);
      card.querySelector('[data-cs-self-serve-minus]')?.addEventListener('click', () => {
        if (input) input.value = String(Math.max(1, Number(input.value || 1) - 1));
        normalizeQuantity(card);
      });
      card.querySelector('[data-cs-self-serve-plus]')?.addEventListener('click', () => {
        if (input) input.value = String(Number(input.value || 1) + 1);
        normalizeQuantity(card);
      });
      input?.addEventListener('change', () => normalizeQuantity(card));
      variant?.addEventListener('change', () => updateProductCard(card));
      card.querySelector('[data-cs-self-serve-product-form]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        void handleSubmit(card);
      });
    });

    dialogClose?.addEventListener('click', () => { pendingAdd = null; closeDialog(); });
    dialogKeep?.addEventListener('click', () => { pendingAdd = null; closeDialog(); });
    dialogSwitch?.addEventListener('click', () => void confirmSwitch());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) { pendingAdd = null; closeDialog(); }
    });
  }

  function refreshState() {
    currentSchedule = buildSchedule();
    currentState = resolveState(currentSchedule);
    syncPreviewContext();
    renderState();
  }

  bindEvents();
  refreshState();
  window.setInterval(refreshState, 30000);
})();
